<template>
  <div class="sitemap-control">
    <p
      class="period-notice"
      :title="$t('observedSitemap.periodNotice')"
    >
      <i class="icon icon--info-outline-gray"></i>
      <span>{{ $t('observedSitemap.periodNotice') }}</span>
    </p>
  </div>
</template>

<script>
export default {
  name: 'SitemapControl'
}
</script>

<style lang="scss" scoped>
.sitemap-control {
  display: flex;
  align-items: center;
  gap: 17px;
  justify-content: space-between;
  height: calc(100% - 50px);
  padding: 0 24px 6px 14px;
  box-sizing: border-box;
  transition: transform 0.3s ease;

  .period-notice {
    display: flex;
    align-items: flex-start;
    gap: 5px;
    margin: 0;
    color: #767673;
    font-size: 12px;
    line-height: 16px;
    margin-top: 2px;
    text-align: end;

    .icon {
      flex: 0 0 12px;
      width: 12px;
      height: 12px;
      margin-top: 2px;
      background-size: 12px;
    }

    span {
      white-space: pre-line;
    }
  }
}
</style>
